import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';;
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { Apollo } from 'apollo-angular';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../core/animations';

/** Service files */
import { SolutionFormService } from '../../../solutionForm.service';

import { printDialogComponent } from '../../../../printDialog/printDialog.component';

/**Query files */
import {
    ScheduleQueryService,
    SolutionMasterQueryService,
    ReportReviewQueryService,
} from '../../../../../queryFiles/index';

/**Local file */

import { spekwoType, pageSizeOptions, pageSize } from '../../../../../utils/index';

@Component({
    selector: 'toggled-list',
    templateUrl: './toggledList.component.html',
    styleUrls: ['./toggledList.component.scss'],
    animations: fuseAnimations
})

export class ToggledListComponent {

    spekwoType = spekwoType;
    pageSizeOptions = pageSizeOptions; //Available options
    pageSize = pageSize; //Initially load data

    dataSource: MatTableDataSource<ReviewData>;
    @ViewChild(MatPaginator) togglePaginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input()
    orderId: number;

    @Input()
    fromPage: string;
    @Input()
    originalEstimate: string;

    @Input() insReportId: string;
    @Output() valueChange = new EventEmitter();
    @Output() isClientAcceptSolutionEvent = new EventEmitter();

    toggledEstimateSubscription: Subscription;

    displayedColumns = ['name', 'description', 'solution'];

    loadSpinner: boolean = true;

    allIcReports: any[] = [];   //This value can used in another component

    totalJobValue: number = 0;


    constructor(
        public apollo: Apollo,
        public dialog: MatDialog,

        /** Service files */
        public solutionFormService: SolutionFormService,

        /** Query files */
        public scheduleQueryService: ScheduleQueryService,
        public solutionMasterQueryService: SolutionMasterQueryService,
        private reportReviewQueryService: ReportReviewQueryService,

    ) {
    }



    ngOnInit() {
        if (this.fromPage === this.spekwoType.solutionPage || this.fromPage === this.spekwoType.requestWorkPageApprove) {
            this.displayedColumns.push('totalCost');
        }
        this.loadSpinner = true;
        if (this.originalEstimate) {
            this.toggledEstimateSubscription = this.reportReviewQueryService.GET_All_STORED_REPORTS(this.orderId).subscribe((res: any) => {
                console.log("res", res);
                if (res && res.data && res.data.allReportReviewDetails && res.data.allReportReviewDetails.edges.length > 0) {
                    this.totalJobValue = 0;
                    res.data.allReportReviewDetails.edges.forEach(detail => {
                        //Finding total job value
                        this.totalJobValue = this.totalJobValue + Number(detail.node.totalCost);
                        this.valueChange.emit(this.totalJobValue);
                        this.allIcReports.push({
                            name: detail.node.subCategoryName ?
                                detail.node.categoryName ?
                                    detail.node.categoryName + ':' + detail.node.subCategoryName
                                    : detail.node.subCategoryName
                                : detail.node.categoryName,
                            description: detail.node.description || '-',
                            imagePath: detail.node.imagePath,
                            solution: detail.node.solution || '-',
                            totalCost: detail.node.totalCost || 0.00,
                            summary: detail.node.solution || '-',
                            itemNumber: detail.node.itemNumWc || '-',
                            mainCategory: detail.node.categoryName,
                            subCategory: detail.node.subCategoryName,
                            insReportId: detail.node.insReportId,
                        });
                        this.loadSpinner = false;
                    });
                    console.log("allIcReports", this.allIcReports);
                    this.dataSource = new MatTableDataSource(this.allIcReports);
                    this.dataSource.paginator = this.togglePaginator;
                }
            });
        }
        else {
            this.toggledEstimateSubscription =
                this.solutionFormService.toggledSolution
                    .subscribe(response => {

                        this.loadSpinner = true;
                        this.allIcReports = [];

                        // Until load data, enable spinner
                        if (response && response.loading) {
                            this.loadSpinner = true;

                        } else if (response && !response.loading) {
                            this.totalJobValue = 0;
                            if (
                                response.masterResponse &&
                                response.masterResponse.length > 0) {

                                _.each(response.masterResponse, (report) => {

                                    var detail = report.node && report.node.reportReviewDetailByReviewId;
                                    //Finding total job value
                                    this.totalJobValue = this.totalJobValue + Number(detail.totalCost);
                                    this.valueChange.emit(this.totalJobValue);
                                    this.allIcReports.push({
                                        name: detail.subCategoryName ?
                                            detail.categoryName ?
                                                detail.categoryName + ':' + detail.subCategoryName
                                                : detail.subCategoryName
                                            : detail.categoryName,
                                        description: detail.description || '-',
                                        imagePath: detail.imagePath,
                                        solution: detail.solution || '-',
                                        totalCost: detail.totalCost || 0.00,
                                        summary: detail.solution || '-',
                                        itemNumber: detail.itemNumWc || '-',
                                        mainCategory: detail.categoryName,
                                        subCategory: detail.subCategoryName
                                    })

                                });

                                if (response.masterResponse.length == this.allIcReports.length) {

                                    this.dataSource = new MatTableDataSource(this.allIcReports);
                                    this.dataSource.paginator = this.togglePaginator;
                                    this.dataSource.sort = this.sort;
                                    if (this.fromPage == 'requestWork') {
                                        this.isClientAcceptSolutionEvent.emit(true);
                                    }
                                    this.loadSpinner = false;
                                    // this.solutionFormService.toggledSolution.complete();

                                }

                            } else {


                                this.allIcReports = [];
                                this.valueChange.emit(this.totalJobValue);
                                if (this.fromPage == 'requestWork') {
                                    this.isClientAcceptSolutionEvent.emit(false);
                                }
                                this.loadSpinner = false;
                            }
                        }
                        this.loadSpinner = false;
                    }, () => {
                        this.loadSpinner = false;
                        this.allIcReports = [];
                    }, () => {
                        this.loadSpinner = false;
                    })
        }
        if (this.orderId != undefined) {
            this.solutionFormService.getClientAcceptedSolution(this.orderId);
        }


    }

    ngOnDestroy() {
        this.toggledEstimateSubscription.unsubscribe();
    }

    printDocument() {

        const dialogRef = this.dialog.open(printDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                arrayData: this.allIcReports,
                action: 'print',
                orderType: 'spekwo',
                pageType: this.fromPage,
            }
        });

        dialogRef.afterClosed()
            .subscribe(response => {

            })
    }
}

export interface ReviewData {
    reviewId: number;
    id: number;
    name: string;
    description: string;
    totalCost: number;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/after-client-accept-list/toggled-list/toggledList.component.ts